var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { ThemeProvider } from "styled-components";
import DoconTile from '../doconTile';
import { FlexBox, BaseBox } from '../../shared/Element';
import { DeleteIcon, PencilIcon } from '../../shared/icons';
import { doconTheme } from "../../../theme/default";
var RightIcons = styled(FlexBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-direction: column;\n  svg {\n    margin: 5px 0;\n    cursor: pointer;\n    &:hover {\n      transform: scale(1.1);\n    }\n  }\n"], ["\n  flex-direction: column;\n  svg {\n    margin: 5px 0;\n    cursor: pointer;\n    &:hover {\n      transform: scale(1.1);\n    }\n  }\n"])));
var Root = styled(DoconTile)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  > * {\n    &:not(:last-child) {\n      margin-right: 12px;\n    }\n  }\n"], ["\n  > * {\n    &:not(:last-child) {\n      margin-right: 12px;\n    }\n  }\n"])));
var DoconCard = function (_a) {
    var leftIcon = _a.leftIcon, showEdit = _a.showEdit, showDelete = _a.showDelete, children = _a.children, iconClick = _a.iconClick, props = __rest(_a, ["leftIcon", "showEdit", "showDelete", "children", "iconClick"]);
    function handleEditClick(e) {
        iconClick && iconClick('edit', e);
    }
    function handleDeleteClick(e) {
        iconClick && iconClick('delete', e);
    }
    return (React.createElement(ThemeProvider, { theme: doconTheme },
        React.createElement(Root, __assign({ alignItems: 'flex-start' }, props),
            leftIcon,
            React.createElement(BaseBox, { flex: 1 }, children),
            (showEdit || showDelete) &&
                React.createElement(RightIcons, null,
                    showEdit && React.createElement(PencilIcon, { width: 16, onClick: handleEditClick }),
                    showDelete && React.createElement(DeleteIcon, { width: 16, onClick: handleDeleteClick })))));
};
export default styled(DoconCard)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3;
